import App from "../packages/offer-filters/App";
import { createRoot } from "react-dom/client";
import { parseHiddenFilters } from "../packages/offer-filters/utils/hiddenFilters";
import { parseLockedFinanceType } from "../packages/offer-filters/utils/financeTypeLock";
const domNode = document.getElementById("react-offer-filters");
if (domNode) {
    const root = createRoot(domNode);
    root.render(<App lockedFinanceType={parseLockedFinanceType(domNode.dataset.lockedFinanceType)} hiddenFilters={parseHiddenFilters(domNode.dataset.hiddenFilters)}/>);
}
